import { NavItemType } from "src/components/ui/navbar/types";
import websiteContent from './website-content.json';

// Import navigation items from centralized content
export const navItems: NavItemType[] = websiteContent.navigation.items as NavItemType[];

// Import footer links from centralized content
export const footerLinks = {
    column1: websiteContent.footer.columns[0].links.map(link => ({
        id: link.href.replace('/', '').replace('#', '') || 'home',
        label: link.label,
        href: link.href
    })),
    // column2: websiteContent.footer.columns[1].links.map(link => ({
    //     id: link.href.replace('/', '').replace('#', '') || 'home',
    //     label: link.label,
    //     href: link.href
    // })),
    column3: websiteContent.footer.columns[2].links.map(link => ({
        id: link.href.replace('/', '').replace('#', '') || 'home',
        label: link.label,
        href: link.href
    }))
};